import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TruncateTooltipModule } from '../truncate-tooltip/truncate-tooltip.module';
import { IconButtonDirective } from './icon-button.directive';

@NgModule({
  declarations: [IconButtonDirective],
  imports: [CommonModule, TruncateTooltipModule],
  exports: [IconButtonDirective]
})
export class IconButtonModule {
}
